var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNoChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 61,
    viewBox: "0 0 91 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7082_300478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.4904 8H3.20064C2.12117 8 1.24609 8.87508 1.24609 9.95455V49.0455C1.24609 50.1249 2.12117 51 3.20064 51H87.4904C88.5699 51 89.445 50.1249 89.445 49.0455V9.95455C89.445 8.87508 88.5699 8 87.4904 8Z",
    fill: "#4F4C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4904 8H3.20064C2.12117 8 1.24609 8.87508 1.24609 9.95455V49.0455C1.24609 50.1249 2.12117 51 3.20064 51H87.4904C88.5699 51 89.445 50.1249 89.445 49.0455V9.95455C89.445 8.87508 88.5699 8 87.4904 8Z",
    fill: "#4F4C57"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8782 22.9148L36.0211 20.0576L35.0109 21.0678L55.1305 41.1874L56.1406 40.1772L53.0587 37.0952H53.0881C54.786 37.0952 55.9055 35.9448 55.9055 34.1629V29.5915C55.9055 27.7945 54.786 26.7719 53.0881 26.7719H45.7407C44.7933 26.7719 44.0557 27.0642 43.5744 27.6109L42.7863 26.8229C43.417 26.1232 44.3686 25.7418 45.5702 25.7418H50.7601L50.7527 25.4561C50.6415 23.9148 49.6406 22.9148 47.9427 22.9148H38.8782Z",
    id: "black-triangle",
    fill: "#908CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9531 25.7343C34.9531 24.8821 35.2071 24.202 35.6565 23.7235L41.915 29.9821V34.4035C41.915 35.629 42.2561 36.1629 42.6713 36.5012L40.5137 38.5388C40.1653 38.8696 39.9577 39.0125 39.6611 39.0125C39.2459 39.0125 39.0012 38.7118 39.0012 38.2456V36.0576H37.7705C36.0727 36.0576 34.9531 34.9072 34.9531 33.1178V25.7343Z",
    id: "black-triangle",
    fill: "#908CA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9307 34.1629V30.9978L51.9317 39.9987C51.8482 40.0371 51.7514 40.0576 51.6424 40.0576C51.3458 40.0576 51.1382 39.9072 50.7897 39.5764L48.1132 37.0952H45.7407C43.9687 37.0952 42.9307 35.9448 42.9307 34.1629Z",
    id: "black-triangle",
    fill: "#908CA0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7082_300478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.9318,
    height: 43,
    fill: "white",
    transform: "translate(1 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoChat);
export default __webpack_public_path__ + "static/media/icon-no-chat.5219fe108867674720fadce2b7c35ccf.svg";
export { ForwardRef as ReactComponent };